import { memo } from 'react';
import { X, Sparkles } from 'lucide-react';
import { WIZARD_TEXT } from '../../constants/suggestionWizard';

interface WizardHeaderProps {
  onClose: () => void;
}

/**
 * Header component for the suggestion wizard panel.
 * Displays branding and close button.
 */
export const WizardHeader = memo<WizardHeaderProps>(({ onClose }) => {
  return (
    <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 bg-white">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-white" />
        </div>
        <div>
          <h3 className="text-[14px] font-semibold text-gray-900">{WIZARD_TEXT.BRAND_NAME}</h3>
          <p className="text-[11px] text-gray-400">{WIZARD_TEXT.SUBTITLE}</p>
        </div>
      </div>
      <button
        onClick={onClose}
        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
        aria-label="Close wizard"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
});

WizardHeader.displayName = 'WizardHeader';

export default WizardHeader;
